import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import Slider from 'react-slick'
import { ArrowVectorRight } from 'src/components/icons/ArrowVectorRight'
import { ImageWithArtDirection } from 'src/components/ui/Image'
import Link from 'src/components/ui/Link'

import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import './brandCarousel.scss'

import type { BrandCarouselServicesProps } from './brand-Carousel'

const BrandCarousel = ({
  desktop,
  mobile,
  marginTop,
  marginBottom,
}: BrandCarouselServicesProps) => {
  const { isMobile } = useBreakpoint()

  const { title, text, href } = isMobile ? mobile : desktop

  const sources = isMobile ? mobile.sources : desktop.sources

  const settings = {
    arrows: true,
    className: 'release-shelf',
    initialSlide: 0,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 10,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 10,
          slidesToScroll: 2,
          arrows: true,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 9,
          slidesToScroll: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2,
          arrows: false,
        },
      },
    ],
  }

  const imagesConf = {
    desktop: {
      height: 180,
      quality: 100,
      aspectRatio: 1,
      backgroundColor: '#EDEDED',
      options: {
        fitIn: true,
      },
    },
    mobile: {
      height: 180,
      quality: 100,
      aspectRatio: 1,
      backgroundColor: '#EDEDED',
      options: {
        fitIn: true,
      },
    },
  }

  return (
    <>
      <section
        className="brand-carousel"
        style={{ marginTop: `${marginTop}`, marginBottom: `${marginBottom}` }}
      >
        <div className="brand-carousel-container">
          <div className="brand-carousel-container-text">
            <h2 className="brand-carousel-container-text__title">{title}</h2>
            <Link
              className="brand-carousel-container-text__link"
              as="a"
              href={href ?? ''}
            >
              {text}
              <ArrowVectorRight
                width={5}
                height={8}
                className="brand-carousel-container-text__icon"
              />
            </Link>
          </div>
          <div className="brand-carousel-container-source">
            <Slider {...settings} className="brand-carousel-container-source">
              {sources?.map((source, index) => (
                <div
                  key={index}
                  className="brand-carousel-container-source-image-container"
                >
                  <Link
                    className="brand-carousel-container-source-image-container-link"
                    as="a"
                    href={source.href}
                  >
                    <ImageWithArtDirection
                      desktop={{
                        baseUrl: `${source.srcSet}`,
                        ...imagesConf.desktop,
                      }}
                      mobile={{
                        baseUrl: `${source.srcSet}`,
                        ...imagesConf.mobile,
                      }}
                      alt={source.alt}
                      objectFit="contain"
                      loading="lazy"
                      className="brand-carousel-container-source-image-container-link__img"
                    />
                    <p className="brand-carousel-container-source-image-container-link__text">
                      {source.text}
                    </p>
                  </Link>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
    </>
  )
}

export default BrandCarousel
